export default __webpack_public_path__ + "static/ulaLogo-2cb5f24e49e4d4ff26c257599b4091d2.webp";